module.exports = __webpack_public_path__ + "img/CameraOutdoorOutlined.0595b486.svg";